'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n'], ['\n  position: relative;\n  display: inline-block;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: none;\n  position: absolute;\n  background-color: ', ';\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px ', ';\n  padding: 5px;\n  z-index: 5000;\n  text-align: left;\n  top: 0;\n  border: 1px ', ' solid;\n  p {\n    margin: 0;\n    padding: 10px 5px;\n    :hover {\n      background-color: ', ';\n      cursor: pointer;\n    }\n  }\n'], ['\n  display: none;\n  position: absolute;\n  background-color: ', ';\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px ', ';\n  padding: 5px;\n  z-index: 5000;\n  text-align: left;\n  top: 0;\n  border: 1px ', ' solid;\n  p {\n    margin: 0;\n    padding: 10px 5px;\n    :hover {\n      background-color: ', ';\n      cursor: pointer;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MozartModal = require('../../MozartDialog/MozartModal');

var _MozartModal2 = _interopRequireDefault(_MozartModal);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Content = _styledComponents2.default.div(_templateObject);

var Subheader = _styledComponents2.default.div(_templateObject);

var IconContainer = _styledComponents2.default.div(_templateObject2);

var Container = _styledComponents2.default.div(_templateObject3);

var List = _styledComponents2.default.div(_templateObject4, _color2.default.white, _color2.default.grey_accent_2, _color2.default.blue_accent, _color2.default.grey_accent_2);

var MozartPopover = function (_Component) {
  _inherits(MozartPopover, _Component);

  function MozartPopover(props) {
    _classCallCheck(this, MozartPopover);

    var _this = _possibleConstructorReturn(this, (MozartPopover.__proto__ || Object.getPrototypeOf(MozartPopover)).call(this, props));

    _this.state = {
      open: false,
      open_details: false,
      message_details: ''
    };
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  _createClass(MozartPopover, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'getList',
    value: function getList() {
      var _this2 = this;

      var list = this.props.list;

      var LIST = [];
      list.forEach(function (item, index) {
        LIST.push(_react2.default.createElement(
          'div',
          { key: index, id: 'binary_popover_' + index },
          _react2.default.createElement(
            'div',
            { onClick: _this2.showDetails.bind(_this2, item) },
            item.primaryText,
            item.secondaryText
          )
        ));
      });
      return LIST;
    }
  }, {
    key: 'getNoData',
    value: function getNoData() {
      return _react2.default.createElement(
        'div',
        { id: 'binary_popover_none' },
        'No Data Yet!'
      );
    }
  }, {
    key: 'showDetails',
    value: function showDetails(item) {
      var _this3 = this;

      if (item.detail !== null) {
        this.setState({
          open_details: true,
          message_details: item.detail
        }, function () {
          document.removeEventListener('mousedown', _this3.handleClickOutside);
        });
      }
    }
  }, {
    key: 'handleOpenDetails',
    value: function handleOpenDetails() {
      var _this4 = this;

      this.setState({
        open_details: true
      }, function () {
        document.removeEventListener('mousedown', _this4.handleClickOutside);
      });
    }
  }, {
    key: 'handleCloseDetails',
    value: function handleCloseDetails() {
      var _this5 = this;

      this.setState({
        open_details: false
      }, function () {
        document.removeEventListener('mousedown', _this5.handleClickOutside);
      });
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      if (this.refs.container && !this.refs.container.contains(event.target)) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      var _this6 = this;

      var _props = this.props,
          node = _props.node,
          list = _props.list;

      if (node || list) {
        this.setState({
          open: true
        }, function () {
          document.addEventListener('mousedown', _this6.handleClickOutside);
        });
      }
    }
  }, {
    key: 'handleRequestClose',
    value: function handleRequestClose() {
      var _this7 = this;

      this.setState({
        open: false
      }, function () {
        document.removeEventListener('mousedown', _this7.handleClickOutside);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          list = _props2.list,
          title = _props2.title,
          style = _props2.style,
          node = _props2.node,
          icon = _props2.icon,
          maxHeight = _props2.maxHeight,
          closeOnClick = _props2.closeOnClick,
          themeId = _props2.themeId;


      return _react2.default.createElement(
        Container,
        { 'data-theme': themeId },
        _react2.default.createElement(
          _MozartModal2.default,
          {
            style: { 'zIndex': 9999999, position: 'absolute' },
            title: '',
            show: this.state.open_details,
            id: id,
            onClose: this.handleCloseDetails.bind(this)
          },
          this.state.message_details
        ),
        _react2.default.createElement(
          IconContainer,
          { onClick: this.onClick.bind(this) },
          icon ? icon : 'Open'
        ),
        _react2.default.createElement(
          'div',
          { ref: 'container' },
          _react2.default.createElement(
            List,
            { style: this.state.open ? Object.assign({ display: 'block' }, style) : Object.assign({ display: 'none' }, style) },
            _react2.default.createElement(
              Subheader,
              { onTouchTap: closeOnClick && this.handleRequestClose.bind(this), style: { padding: '0px' } },
              title
            ),
            list && _react2.default.createElement(
              Content,
              { style: maxHeight ? { maxHeight: maxHeight } : {} },
              list.length > 0 && this.getList(),
              list.length === 0 && this.getNoData()
            ),
            node && _react2.default.createElement(
              Content,
              { onClick: this.handleRequestClose.bind(this) },
              node
            )
          )
        )
      );
    }
  }]);

  return MozartPopover;
}(_react.Component);

MozartPopover.propTypes = {
  /** style override */
  style: _propTypes2.default.object,
  /** id */
  id: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** DOM node used to trigger */
  icon: _propTypes2.default.node,
  /** title */
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** max height */
  maxHeight: _propTypes2.default.string,
  /** content of popover DOM node */
  node: _propTypes2.default.node,
  /** content of popover array of object */
  list: _propTypes2.default.array,
  /** close the popover on click */
  closeOnClick: _propTypes2.default.bool
};
MozartPopover.defaultProps = {
  closeOnClick: false,
  themeId: 'MozartPopover'
};
exports.default = MozartPopover;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartDropDown/MozartPopover/MozartPopover.js
// module id = 1847
// module chunks = 1